import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MediaLocalAssetPipe } from './media-local-asset.pipe';
import { MediaDirective } from './media.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [MediaDirective, MediaLocalAssetPipe],
  exports: [MediaDirective, MediaLocalAssetPipe],
})
export class MediaModule {
  static forRoot(): ModuleWithProviders<MediaModule> {
    return {
      ngModule: MediaModule,
    };
  }
}
